import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { InputValidationTypes } from '../InputValidationTypes.enum';
import { ValidationService } from '../../services/validation.service';

@Component({
  selector: 'app-inline-edit-textfield',
  templateUrl: './inline-edit-textfield.component.html',
  styleUrls: ['./inline-edit-textfield.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InlineEditTextfieldComponent implements OnInit {
  public buttonInEditMode: boolean;
  public editingText: string;
  private _originalValue: string;
  @Input() public labelText: string;
  @Output() public onUpdate: EventEmitter<string> = new EventEmitter();
  @Input() public showConfirmation: false;
  @Input() public confirmationText: string;
  @Input() public confirmationTitle: string;
  @Input() public validations: InputValidationTypes[];
  public minLength = 4;
  @Input() public optionalClasses: string;
  public required: true;
  public validationError: string;
  @Output() public onFocusOut: EventEmitter<void> = new EventEmitter();
  @ViewChild('input') public input: ElementRef;
  @Input() public disableHint: boolean;

  @Input()
  set inputValue(inputValue: string) {
    this._originalValue = inputValue;
    this.editingText = this._originalValue;
  }

  constructor(
    private confirmationDialogService: ConfirmationDialogService,
    private validationService: ValidationService,
  ) {}

  ngOnInit() {}

  public openEditMode() {
    if (!this.buttonInEditMode) {
      this.buttonInEditMode = true;
    }
  }

  public closeEditMode(forceClose?: boolean) {
    if (forceClose === true || (this.buttonInEditMode && this.editingText === this._originalValue)) {
      this.buttonInEditMode = false;
    }
  }

  public emitUpdate(event) {
    event.stopPropagation();
    this.validationError = this.validationService.validateInput(this.editingText, this.validations, this.minLength);
    if (this.validationError) {
      return;
    }
    if (this.showConfirmation) {
      this.confirmationDialogService
        .confirm({ title: this.confirmationTitle, text: this.confirmationText })
        .subscribe((confirmed) => (confirmed === true ? this.onUpdate.emit(this.editingText) : null));
    } else {
      this.onUpdate.emit(this.editingText);
    }
  }

  public focusOut() {
    this.onFocusOut.emit();
    this.closeEditMode();
  }
}
